import styled from "styled-components";

export const AppNav = styled.div`
  display: flex;
  flex-direction: row;
  
  justify-content: center;
  align-items: center;
  
  width: 100%;
  height: 15%;
  
  margin-top: auto;
`;
